<script context="module" lang="ts">
  export const key = 'mobileNavModal';
  const closeAt = 960;
</script>

<script lang="ts">
  import Modal from '$components/Modals/Modal.svelte';
  import { modals } from '$lib/stores/modals';
  import GlobalNav from './GlobalNav.svelte';

  $: isOpen = $modals.has(key);
</script>

<Modal
  autoCloseAt={closeAt}
  size="fullscreen"
  modalKey={key}
  ariaLabel="Open navigation modal"
  withBackdrop={false}
  let:onCloseClicked={handleCloseClicked}
>
  <GlobalNav mobileNavOpen={isOpen} {handleCloseClicked} />
</Modal>
